import React, { useState, useEffect } from "react";
import "components/Layout/style.css";
import FermeImg from "assets/img/ferme.svg";
import Grid from "@mui/material/Grid";
import { useStore } from "_Store";
import WelcomeLayout from "pages/Shared/WelcomeLayout";
import Accordion from "components/Ui/Accordion";
import useSeedData from "hooks/useSeedData";
import {getFilterCahierByType} from "services/cachier.service";
import Loading from "components/Ui/Loading"
import { getSeed } from "services/stock.service";
const CahierFarmParcel = (props) => {
  const { state, setTableData } = useStore();
  const { data: seedList } = useSeedData();
  const [selectedValue, setSelectedValue] = useState(state?.["cahierTableDataResponse"]?.["seed"] || "");
  const [expanded, setExpanded] = useState("");
  const [errors, setErrors] = useState("");
  const [loading, setLoading] = useState(false);
  const [commodities, setCommodities] = useState([]);
  const [seedDatas, setSeedData] = React.useState([]);
  const data = state.cahierTableDataResponse;
  const {
    state: {
      activeFarm,
      activeCampaign,
      //farmList,
      userProfile
    },setUtils
  } = useStore();
 // getFilterCahierByType
  useEffect(() => {
    setLoading(true)
    getSeedData();
    setExpanded(activeFarm.id)
  }, []);
  useEffect(() => {
    setUtils("loading", { spinning: true, primary: "" });
   // const {cashTransaction} = props.formData;
    if(data.cashTransaction==="ENTRIES"){
      setCommodities(seedDatas);
      setLoading(false)
      setUtils("loading", { spinning: false, primary: "" });
    }else{
        let seeds=[];
        getFilterCahierByType({ campaignId: activeCampaign.id, filterType: 'ENTRIES' })
          .then(res => {
              const allEntrieCahiers = res.data.data;
              allEntrieCahiers.map((res)=>{
                if(seeds.indexOf(res.seed)< 0){
                  seeds.push(res.seed);
                }
              });
            let dataSeeders = seedDatas?.filter((res)=>seeds.indexOf(res.id));
            setCommodities(dataSeeders);
            setLoading(false)
            setUtils("loading", { spinning: false, primary: "" });
        })
        .catch(err => null)
    }
    setExpanded(activeFarm.id)
  }, [data, activeCampaign, seedDatas]);
  const validation = () => {
    if (expanded && selectedValue) {
      return true;
    } else {
      setErrors("Une option radio est requise");
      return false;
    }
  };
  const handleSubmit = (save) => {
    const res = validation();
    if (res) {
      props.onSubmit({ farmId: activeFarm.id, seed: selectedValue }, save);
      setTimeout(() => {
      }, 800);
    }
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleSelect = (event) => {
    setSelectedValue(Number(event.target.value));
    setErrors("");
  };
 
  function getSeedData(){
    let products = activeCampaign.productsYouGrow,
        data =[];
    if(products && products.length > 0){
       for(const product of products){
         let seed = product.seed;
         data=[...data,{id: seed.id,name: seed.seedName}];
       }
     }
     setSeedData(data)
   }

  return (
    <div>
      <div className="text-center">
        {loading ? <Loading/> : null }
      </div>
      <Grid className="stepFormfields">
        <WelcomeLayout
          title={"Champs"}
          containImg={FermeImg}
          content={"Journal de caisse"}
          handleSubmit={handleSubmit}
          task={"Chaque opération que vous enregistré doit être associé à une culture. Veuillez choisir la culture sur laquelle l'opération a été réaliser."}
          buttonDisabled={!commodities || (commodities && commodities.length <= 0)}
          backToStartBtn={{ 
            label:'précédent',
            onClick: () => {
              props.onBack();
            } 
          }}
          buttonLabel={"Continuer"}
        >
          <div>
          {loading ? <Loading/> : null }
            {commodities && commodities.length > 0 ? 
              <div className="questionPage">
                    <Accordion
                      key={activeFarm.id}
                      expanded={expanded === activeFarm.id}
                      title={activeFarm.farmName}
                      subTitle={activeFarm.area+" hectares"}
                      data={activeFarm}
                      errors={errors}
                      label={
                        "Veuillez choisir une culture"}
                      options={commodities}
                      handleChange={handleChange}
                      optionSelection={handleSelect}
                      value={selectedValue}
                      isFarm={true}
                      radioButtonClass={"accordionRadio"}
                    />
                {errors?.length > 1 && <p className="errorText">{errors}</p>}
              </div>
              : (loading ? null : <div className="errorText text-center mt-10 mb-10">Vous ne pouvez pas enregistrer une sortie sans au préalable avoir ajouter une entrée pour vos cultures</div>) }
          </div>
        </WelcomeLayout>
      </Grid>
    </div>
  );
};

export default CahierFarmParcel;
